import { Stack, Text } from "@fluentui/react";
import { RegisterTextField } from "../Common/RegisterField";
import { useEffect, useState } from "react";
import { useBreakpoint } from "../../../Container/ContainerStyles";
import { BreakpointType } from "../../../Container/ContainerFluid";
import { containerStyles, formContainerStyles, lgContainerStyles, lgSubTitleStyles, lgTitleContainerStyles, lgTitleStyles, mdContainerStyles, mdSubTitleStyles, mdTitleContainerStyles, mdTitleStyles, smContainerStyles, smSubTitleStyles, smTitleContainerStyles, smTitleStyles, subTitleStyles, titleContainerStyles, titleStyles, xlContainerStyles, xlSubTitleStyles, xlTitleContainerStyles, xlTitleStyles, xxlContainerStyles, xxlSubTitleStyles, xxlTitleContainerStyles, xxlTitleStyles } from "../Common/Styles/CommonStyles";
import { IRegisterContext, useRegisterContext } from "../../RegisterContainer";
import { RegisterService } from "../../Service/RegisterService";
import { LeadToLiveStep } from "../../../../../Model/CommonModel";

export const RegisterVAT: React.FC = () => {
    const registerContext: IRegisterContext = useRegisterContext();
    const [vat, setVat] = useState<string>(registerContext.leadToLive.lead.vat);
    
    const isSM = useBreakpoint(BreakpointType.sm);
    const isMD = useBreakpoint(BreakpointType.md);
    const isLG = useBreakpoint(BreakpointType.lg);
    const isXL = useBreakpoint(BreakpointType.xl);
    const isXXL = useBreakpoint(BreakpointType.xxl);

    useEffect(() => {
        if(registerContext.leadToLive.currentStep !== LeadToLiveStep.VAT)
            return;

        registerContext.setFooterButtonProps({...registerContext.footerButtonProps, backButtonDisabled: true, backButtonHidden: true});
    }, []);

    // Update the context when the vat is updated
    useEffect(() => {
        if(vat){
            if(vat.length === 11) {
                registerContext.setLeadToLive({...registerContext.leadToLive, lead: {...registerContext.leadToLive.lead, vat: vat}});
            }
        }
    }, [vat]);

    return (
        <Stack
            className={
                isSM ? 
                    smContainerStyles : 
                isMD ? 
                    mdContainerStyles :
                isLG ?
                    lgContainerStyles :
                isXL ?
                    xlContainerStyles :
                isXXL ?
                    xxlContainerStyles
                :
                    containerStyles
            }
        >
            <Stack
                className={
                    isSM ? 
                        smTitleContainerStyles : 
                    isMD ? 
                        mdTitleContainerStyles :
                    isLG ?
                        lgTitleContainerStyles :
                    isXL ?
                        xlTitleContainerStyles :
                    isXXL ?
                        xxlTitleContainerStyles
                    :
                        titleContainerStyles
                }
            >
                <Text 
                    className={
                        isSM ? 
                            smTitleStyles : 
                        isMD ? 
                            mdTitleStyles : 
                        isLG ?
                            lgTitleStyles :
                        isXL ?
                            xlTitleStyles :
                        isXXL ?
                            xxlTitleStyles
                        :
                            titleStyles
                    }
                >
                    {RegisterService.translate("vat:title")}
                </Text>
                <Text 
                    className={
                        isSM ? 
                            smSubTitleStyles : 
                        isMD ? 
                            mdSubTitleStyles :
                        isLG ?
                            lgSubTitleStyles :
                        isXL ?
                            xlSubTitleStyles :
                        isXXL ?
                            xxlSubTitleStyles
                        :
                            subTitleStyles
                    }
                >
                    {RegisterService.translate("vat:description")}
                </Text>
            </Stack>
            <Stack
                className={formContainerStyles}
            >
                <RegisterTextField 
                    placeholder={RegisterService.translate("vat:placeholder")}
                    value={vat}
                    onChange={(value) => setVat(value)}
                    onlyNumbers
                    maxLength={11}
                    autoFocus
                    errorMessage={RegisterService.getErrorMessage(registerContext.registerError, "vat")}
                />
            </Stack>
        </Stack>
    );
};